import Skeleton from 'react-loading-skeleton';

import Card from '~/shared/components/Card';
import Typography from '~/shared/components/Typography';
import SavingsIcon from '~/shared/assets/icons/savings-icon.svg';

import CircularProgress from '../../common/CircularProgress';

export default function MonthlySavingsCard({
  savings,
  potential,
  percentage,
  loading,
}: {
  savings: string;
  potential: string;
  percentage: number;
  loading: boolean;
}) {
  return (
    <Card className="flex justify-between items-center">
      <div className="flex  flex-col gap-[18px]">
        <div className="flex items-center gap-[9px]">
          <SavingsIcon className="size-8" />
          <div className="flex flex-col gap[3px]">
            <Typography fontWeight={500} variant="p3" color="text-primary-900">
              Estimated Monthly Saving Using Datafy
            </Typography>
            <Typography variant="caption" color="text-gray-700">
              Out of volumes that are eligible for auto-scaling
            </Typography>
          </div>
        </div>
        {loading ? (
          <Skeleton
            containerClassName="h-[30px] block"
            className="h-[30px]  rounded-[8px]"
            baseColor="var(--color-gray-200)"
            highlightColor="#FFFF"
            width={205}
          />
        ) : (
          <div className="flex items-center gap-[20px]">
            <Typography
              fontWeight={500}
              variant="H1-med"
              color="text-[#2D2D32]"
              className="font-family-outfit"
            >
              {savings}
            </Typography>
            <Typography
              // fontWeight={400}
              variant="p3-reg"
              color="text-primary-900"
              className="px-2 py-1 bg-gray-200 rounded-[4px] font-family-inter"
            >
              / {potential}
            </Typography>
          </div>
        )}
      </div>
      <CircularProgress percentage={percentage} loading={loading} />
    </Card>
  );
}
